import styled from 'styled-components';
import {
  Flex,
  Text,
} from 'web-styled';

export const Layout = styled(Flex).attrs({
  align: 'center',
  justify: 'center',
  fillSpace: true,
  column: true,
  spacing: 40,
})`
  height: 100%;
  width: 100%;
  padding: 0 15px;
  color: #999;
`;

export const Links = styled(Flex).attrs({
  justify: 'space-between',
})`
  width: 100%;
  max-width: 700px;
  padding: 0 10px;

  & > a {
    width: 50%;
  }
`;

export const Title = styled(Text).attrs({
  color: '#090909',
  size: '1.3em',
})`
  font-style: normal;
  line-height: 1.4em;
  line-height: 1.4em;
  text-align: center;
  word-break: initial;
  margin: 0;
`;
